import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tech-features',
  templateUrl: './tech-features.component.html',
  styleUrls: ['./tech-features.component.scss']
})
export class TechFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
